import { Link, NavLink, To } from "react-router-dom";
import { twMerge } from "tailwind-merge";

interface BreadcrumbItemProps {
  title: String;
  navigateTo: To;
}
const BreadcrumbItem = ({ title, navigateTo }: BreadcrumbItemProps) => {
  return (
    <NavLink
      to={navigateTo}
      // className="opacity-60"
      className={({ isActive, isPending }) =>
        twMerge(
          "no-underline",
          isActive ? "text-primaryText font-medium" : "text-tertiaryText"
        )
      }
    >
      <span className="text-xl">{title}</span>
    </NavLink>
  );
};

export default BreadcrumbItem;
